import React, {FC} from 'react'
import clsx from 'clsx'

export const StarRatingDisplay: FC<{value: number}> = ({value}) => {
  const n = Math.min(5, Math.max(0, Math.round(Number(value) || 0)))
  return (
    <span className='d-inline-flex align-items-center gap-0' aria-label={`${n} / 5`}>
      {Array.from({length: 5}, (_, i) => (
        <i
          key={i}
          className={clsx(
            'bi fs-6',
            i < n ? 'bi-star-fill text-warning' : 'bi-star text-muted opacity-50'
          )}
        />
      ))}
    </span>
  )
}
